
import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCcw } from 'lucide-react';
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';

interface IntegrationFormProps {
  form: UseFormReturn<any>;
  inputs: {
    name: string;
    label: string;
    placeholder: string;
    description: string;
    type: string;
  }[];
  onSubmit: (data: any) => void;
  onTestConnection: () => void;
  isTesting: boolean;
  integrationSlug: string;
}

const IntegrationForm: React.FC<IntegrationFormProps> = ({
  form,
  inputs,
  onSubmit,
  onTestConnection,
  isTesting,
  integrationSlug
}) => {
  return (
    <Form {...form}>
      <form 
        onSubmit={form.handleSubmit(onSubmit)}
        className="space-y-4"
      >
        {inputs.map((input) => (
          <FormField
            key={input.name}
            control={form.control}
            name={input.name}
            render={({ field }) => (
              <FormItem>
                <FormLabel>{input.label}</FormLabel>
                <FormControl>
                  <Input
                    {...field}
                    type={input.type}
                    placeholder={input.placeholder}
                  />
                </FormControl>
                <FormDescription>{input.description}</FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />
        ))}
        <div className="flex justify-end space-x-2">
          <Button 
            type="button"
            variant="outline"
            onClick={onTestConnection}
            disabled={isTesting}
          >
            {isTesting ? (
              <>
                <RefreshCcw className="h-4 w-4 mr-2 animate-spin" />
                Testing...
              </>
            ) : (
              'Test Connection'
            )}
          </Button>
          <Button type="submit">Save Configuration</Button>
        </div>
      </form>
    </Form>
  );
};

export default IntegrationForm;
